import { useGetSurveyMediaFileQuery } from "@/services/media";
import { useAppSelector } from "@app/hooks";
import { skipToken } from "@reduxjs/toolkit/query";

const MarketMapImage = () => {
  const survey = useAppSelector((state) => state.survey.currentSurvey);
  const surveyId = survey?.id;

  // Query for market map media file
  const { data: marketMapMedia, isLoading } = useGetSurveyMediaFileQuery(
    surveyId ? { surveyId, mediaType: "MARKETMAP" } : skipToken,
  );

  // Get the last uploaded image
  const uploadedImageUrl =
    marketMapMedia?.media?.[marketMapMedia.media.length - 1]?.cloudfrontUrl;
  if (isLoading || !uploadedImageUrl) {
    return (
      <div className="w-full text-center text-2xl min-h-[500px] grid place-items-center">
        <div>Loading...</div>
      </div>
    );
  }

  return (
    <div className="w-full flex items-center min-h-[500px] justify-center bg-gray-50 h-[auto]">
      <img
        src={uploadedImageUrl}
        alt="Market Map"
        className="w-full object-cover"
      />
    </div>
  );
};

export default MarketMapImage;
